// Both logo captions are compliance paragraphs. Their md column caps them at ~261px, but on the sm
// and xs tiers each logo takes a full-width row, where the text would otherwise run to a 130
// character measure and read as stretched. 40rem is 400px here, roughly 70-80 characters.
export const LOGO_CAPTION_MAX_WIDTH = '40rem';

export const useStylesFooterLayout = (isMobile, theme) => {
	return {
		// Desktop has no tap-to-call, so the number is inert above the sm breakpoint.
		Phone: {
			pointerEvents: isMobile ? 'auto' : 'none'
		},
		// Border longhand rather than the `border-top` shorthand: the shorthand resets
		// border-top-color to currentColor, which inside the footer AppBar resolves to MUI's
		// default contrast colour, not the channel's footer colour. Element opacity rather than
		// alpha() because footerTextColor is free text from a channel setting and alpha() throws
		// on CSS named colours such as `white`.
		divider: {
			borderTopWidth: '1px',
			borderTopStyle: 'solid',
			borderTopColor: theme.palette.footer.fontColor,
			opacity: 0.2,
			marginTop: '4rem',
			marginBottom: '2.4rem'
		},
		recaptchaText: {
			textAlign: 'center',
			fontSize: '1.2rem',
			lineHeight: 1.6,
			color: theme.palette.footer.fontColor
		}
	};
};

export const useStylesFooterLogo = (theme, secondaryLogoTextColor) => {
	return {
		logo: {
			height: 'auto',
			width: 'auto',
			maxHeight: '100px',
			maxWidth: '120px',
			display: 'flex'
		},
		// `||` rather than `??`: getChannelSettingByKey returns the raw stored value, so a channel
		// that has the setting but left it blank yields '', which `??` would pass through as
		// `color: ''`. React drops that and the caption silently inherits the AppBar's contrast
		// colour instead of the channel's footer colour.
		logoText: {
			fontSize: '1.2rem',
			lineHeight: 1.6,
			color: secondaryLogoTextColor || theme.palette.footer.fontColor,
			marginTop: '1.2rem',
			textAlign: 'center',
			maxWidth: LOGO_CAPTION_MAX_WIDTH
		}
	};
};
